<template>
  <div class="search-container">
    <div class="search-left">
      <el-input
        :placeholder="namePlaceholder"
        suffix-icon="el-icon-search"
        size="mini"
        @blur="searchFn"
        @clear="searchFn"
        v-model="searParam.sopName"
        clearable
        style="width: 180px; margin-right: 10px"
      >
      </el-input>
      <div class="create-time">创建时间</div>
      <el-date-picker
        v-model="searParam.searchSelectTime"
        size="mini"
        type="daterange"
        :editable="false"
        value-format="yyyy-MM-dd"
        range-separator="~"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        @change="selectTime"
        clearable
        style="width: 240px; margin-right: 10px;border-radius: 0 4px 4px 0;"
      >
      </el-date-picker>
    </div>
    <div class="search-right">
      <el-button type="primary" v-if="KHSOPxbc" size="mini"  @click="createSOP">{{namePlaceholder=='搜索SOP任务名称'?'新建SOP':'新建群发'}} </el-button>
    </div>
  </div>
</template>
<script>

export default {
  name: "search",
  props: {
    name: {
      type: String,
      default() { return '' }
    },
    namePlaceholder: {
      type: String,
      default() { return '搜索SOP任务名称' }
    },
    searchSelectTime: {
      type: Array,
      default() { return [] }
    },
    // 可新建/编辑/删除
    KHSOPxbc: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searParam: {
        sopName: '',
        searchSelectTime: []
      },
      
    };
  },
  created() {
  },
  watch: {
  },
  computed: {
  },
  methods: {
    selectTime(value) {
      console.log('valueSearch',value)
      this.$emit('selectTime',value)
    },
    searchFn() {
      this.$emit('searchFn',this.searParam.sopName)
    },
    createSOP(value) {
      this.$emit('createSOP',value)
    },
  }
};
</script>
<style lang="scss" scoped>
.search-container {
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  .search-left {
    display: flex;
    .create-time {
      font-size: 14px;
      display: flex;
      align-items: center;
      padding: 0 4px;
      border: 1px solid #DCDFE6;
      border-right: none;
    }
  }
  .search-right {
    display: flex;
    justify-content: space-between;
  }
}
</style>